const config = {
  // REQUIRED
  appName: "CallGym",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "Simulateur d'appels avec IA pour s'entraîner aux rendez-vous commerciaux. Améliorez vos compétences en prospection, qualification, découverte, démo et closing grâce à un outil fun, simple et éducatif.",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "callgym.com",
  // URL used by every "Book a demo" CTA on the public website
  demoUrl: "https://cal.eu/callgym/30min",
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (resend.supportEmail) otherwise customer support won't work.
    id: "",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  stripe: {
    // Create multiple plans in your Stripe dashboard, then add them here. You can add as many plans as you want, just make sure to add the priceId
    plans: [
      {
        // REQUIRED — we use this to find the plan in the webhook (for instance if you want to update the user's credits based on the plan)
        priceId:
          process.env.NODE_ENV === "development"
            ? "price_1Niyy5AxyNprDp7iZIqEyD2h"
            : "price_456",
        //  REQUIRED - Name of the plan, displayed on the pricing page
        name: "Performance",
        // A friendly description of the plan, displayed on the pricing page. Tip: explain why this plan and not others
        description: "Pratique et progresse",
        // The price you want to display, the one user will be charged on Stripe.
        price: 59,
        // If you have an anchor price (i.e. $29) that you want to display crossed out, put it here. Otherwise, leave it empty
        priceAnchor: 99,
        features: [
          {
            name: "Prospects IA réalistes",
          },
          { name: "Coaching personnalisé" },
          { name: "Evaluation des calls" },
          { name: "Transcription" },
          { name: "Analyse des objections" },
          { name: "100 appels IA inclus" },
        ],
      },
      {
        // This plan will look different on the pricing page, it will be highlighted. You can only have one plan with isFeatured: true
        isFeatured: true,
        priceId:
          process.env.NODE_ENV === "development"
            ? "price_1O5KtcAxyNprDp7iftKnrrpw"
            : "price_456",
        name: "Excellence",
        description: "Pratique à fond et devenir le meilleur",
        price: 149,
        priceAnchor: 199,
        features: [
          { name: "Tout ce qui est dans le plan Performance" },
          { name: "Appels IA illimités" },
          { name: "Analyse des appels réels" },

          // { name: "Support prioritaire" },
        ],
      },
    ],
  },
  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  resend: {
    // Email 'From' field to be used when sending magic login links
    fromNoReply: `CallGym <noreply@resend.dev>`,
    // Email 'From' field to be used when sending other emails
    fromAdmin: `CallGym Support <support@resend.dev>`,
    supportEmail: "",
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/sign-in",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/app",
  },
};

export default config;
